/* eslint-env node, browser */
'use strict'

module.exports = function () {
  var self = this

  self.instances.forEach(function (combokeys) {
    combokeys.reset()
  })
}



//////////////////
// WEBPACK FOOTER
// D:/agent/4/_work/121/s/common/~/combokeys/Combokeys/reset.js
// module id = 151
// module chunks = 0